import { Controller } from '@hotwired/stimulus';

// One Range of motion pair: a start box and an end box in whole degrees, the
// way the goals editor's baseline, start of care and target, a visit note's
// session readings and Adjust target, and a progress report's target box all
// take a range ("0-120°"). It keeps the pair from submitting what the server
// refuses (Patient::Goal::RangeValue) while it is typed:
//   - a start higher than the end, flagged on the start box;
//   - one number without the other, flagged on the empty box.
// Whole degrees and the bounds are the boxes' own step, min and max. Both boxes
// blank is no value, and passes. The pair is checked as the page opens too, so
// a value a save refused is flagged again.
//
// Targets:
//   start  the box for where the movement starts (stored as `low`)
//   end    the box for where it ends (stored as `high`)
export default class extends Controller {
  static targets = ['start', 'end'];

  connect() {
    this.check();
  }

  check() {
    if (!this.hasStartTarget || !this.hasEndTarget) return;

    const start = this.startTarget.value.trim();
    const end = this.endTarget.value.trim();
    this.startTarget.setCustomValidity('');
    this.endTarget.setCustomValidity('');
    if (start === '' && end === '') return;

    if (start === '') {
      this.startTarget.setCustomValidity('Enter where the range starts as well as where it ends.');
    } else if (end === '') {
      this.endTarget.setCustomValidity('Enter where the range ends as well as where it starts.');
    } else if (Number(start) > Number(end)) {
      this.startTarget.setCustomValidity('The start cannot be higher than the end.');
    }
  }
}
